/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerIdWithParentId } from './PartnerIdWithParentId';
import {
    PartnerIdWithParentIdFromJSON,
    PartnerIdWithParentIdFromJSONTyped,
    PartnerIdWithParentIdToJSON,
    PartnerIdWithParentIdToJSONTyped,
} from './PartnerIdWithParentId';
import type { CategoryEvent } from './CategoryEvent';
import {
    CategoryEventFromJSON,
    CategoryEventFromJSONTyped,
    CategoryEventToJSON,
    CategoryEventToJSONTyped,
} from './CategoryEvent';

/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    categIds: number;
    /**
     * 
     * @type {CategoryEvent}
     * @memberof Event
     */
    categ?: CategoryEvent;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    stop: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    displayTime: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    duration: number;
    /**
     * 
     * @type {Array<PartnerIdWithParentId>}
     * @memberof Event
     */
    partnerIds: Array<PartnerIdWithParentId> | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    location?: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    partnerId: number;
    /**
     * 
     * @type {PartnerIdWithParentId}
     * @memberof Event
     */
    partnerSelected: PartnerIdWithParentId | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    commercialEmail: string;
}

/**
 * Check if a given object implements the Event interface.
 */
export function instanceOfEvent(value: object): value is Event {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categIds' in value) || value['categIds'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('stop' in value) || value['stop'] === undefined) return false;
    if (!('displayTime' in value) || value['displayTime'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('partnerIds' in value) || value['partnerIds'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    if (!('partnerSelected' in value) || value['partnerSelected'] === undefined) return false;
    if (!('commercialEmail' in value) || value['commercialEmail'] === undefined) return false;
    return true;
}

export function EventFromJSON(json: any): Event {
    return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'categIds': json['categ_ids'],
        'categ': json['categ'] == null ? undefined : CategoryEventFromJSON(json['categ']),
        'userId': json['user_id'],
        'start': json['start'],
        'stop': json['stop'],
        'displayTime': json['display_time'],
        'duration': json['duration'],
        'partnerIds': (json['partner_ids'] == null ? null : (json['partner_ids'] as Array<any>).map(PartnerIdWithParentIdFromJSON)),
        'description': json['description'],
        'location': json['location'] == null ? undefined : json['location'],
        'partnerId': json['partner_id'],
        'partnerSelected': PartnerIdWithParentIdFromJSON(json['partner_selected']),
        'commercialEmail': json['commercialEmail'],
    };
}

export function EventToJSON(json: any): Event {
    return EventToJSONTyped(json, false);
}

export function EventToJSONTyped(value?: Event | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'categ_ids': value['categIds'],
        'categ': CategoryEventToJSON(value['categ']),
        'user_id': value['userId'],
        'start': value['start'],
        'stop': value['stop'],
        'display_time': value['displayTime'],
        'duration': value['duration'],
        'partner_ids': (value['partnerIds'] == null ? null : (value['partnerIds'] as Array<any>).map(PartnerIdWithParentIdToJSON)),
        'description': value['description'],
        'location': value['location'],
        'partner_id': value['partnerId'],
        'partner_selected': PartnerIdWithParentIdToJSON(value['partnerSelected']),
        'commercialEmail': value['commercialEmail'],
    };
}

